<template>
  <div id="noneligibleFeaturepop"  class="animated fadeIn">
    <b-modal  centered hide-footer  id="noneligeble" :no-close-on-backdrop="true" ref="noneligeble">
          <slot name="modal-header">
            <div class="col-12 flex justify-end">
              <button type="button" @click="hidemodal()"  class="white-button no-border not-rounded gibson ">
                <span>
                <i class="pt2 el-icon-close"></i>
                </span>
              </button>
            </div>
          </slot>
          <div class="clearfix " v-if="loading">
            <div class="col-12 ">
              <div class="loader"></div>
              <p class="mediumgrey bold center">Vi sender en besked til vores support team</p>
            </div>
          </div>
          <div class="clearfix white-background  m2" v-else>
            <div class="flex flex-column gibson col-12">
              <!-- <p class="h3 my2 darkblue mx-auto Bold" >Hej {{partnername.replace('&\#039\;','\'')}}!</p> -->
              <p class="h3 my2 darkblue mx-auto Bold" >Hej {{partnername}} !</p>
              <p class="h5 my1  darkblue mx-auto semi-bold" >Denne funktion er ikke i dit abonnement.Få det nu for en bedre brugeroplevelse!</p>
              <p class="h6 my4  darkblue mx-auto center " >Hvis du har kobt denne funktion, skal du ga til forsiden og tilbage til denne side.</p>
              <div class="col-12 flex justify-around my2 p0">
                  <button @click="hidemodal('')" :disabled="buttondisabled" class="col-6 mr1 darkblue-background no-border white p2 h5 regular border-none not-rounded gibson flex justify-center items-center">
                    <span><i class="el-icon-back"></i></span>
                    <span class="mx2">Glem det</span>
                  </button>
                <button @click="requestBitrixFeatures()" :disabled="buttondisabled" class="col-6 darkblue-background no-border p2 white h5 regular border-none not-rounded gibson flex justify-center items-center">
                    <span class="mx2">Få det</span>
                    <span><i class="el-icon-right"></i></span>
                  </button>
              </div>
            </div>
          </div>
        
          <div slot="modal-footer" class="col-12 p2 white-background" ><p>_</p>
          </div>
    </b-modal>
    <b-modal  centered hide-footer  id="successrequestfeature" :no-close-on-backdrop="true" ref="successrequestfeature">
          <div class="py1" ></div>
          <div class="clearfix white-background  m2">
            <div class="flex flex-column gibson col-12">
              <p class="my2 darkblue mx-auto " ><i class="el-icon-document-checked green" style="font-size:4em"></i></p>
              <p class="semi-bold h3 darkblue pt1 mx-auto" >Tak for din henvendelse,</p>
                <p class="h4 darkblue py1 mx-auto" >Vi ringer til dig hurtigst muligt</p>
              <button @click="hidemodaltak('')" class=" my2 col-4 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center">
                <span class="mx2 my1">Luk</span>
              </button>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 p2 white-background" ><p>_</p>
          </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'noneligibleFeaturepop',
  props: ['eligibilitydata'],
  data () {
    return {
      partnername: '',
      partnerData: [],
      salesPerson: '',
      haaid: '',
      packagehandle: '',
      partneremail: '',
      partnertelephone: '',
      actualfeaturecode: [],
      wheretogo: '',
      loading: false,
      buttondisabled: true
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaid = localStorage.getItem('haaid')
    this.packagehandle = localStorage.getItem('PartnerPackageHandle')
    this.getPartner()
  },
  methods: {
    showmodel (iseligible, directto = '', featurecode = '') {
      this.partnerData['eligible'] = iseligible
      if (directto !== '') {
        this.partnerData['linkreferer'] = directto
      } else {
        this.partnerData['linkreferer'] = this.$router.history.current.fullPath
      }
      this.actualfeaturecode.push(featurecode)
      this.$refs.noneligeble.show()
    },
    hidemodal (togohide = '') {
      this.$refs.noneligeble.hide()
      if (togohide === '') {
        this.goto()
      }
    },
    hidemodaltak (togohide = '') {
      this.$refs.successrequestfeature.hide()
      if (togohide === '') {
        this.goto()
      }
    },
    goto () {
      this.$router.push(this.partnerData['linkreferer'])
    },
    // closemodalforgetit () {
    //   var modal = document.getElementById('noneligeble___BV_modal_outer_')
    //   modal.style.zIndex = 202
    //   var modal2 = document.getElementById('noneligeble___BV_modal_content_')
    //   modal2.style.display = 'none'
    //   modal2.style.marginTop = '0% '
    // },
    getPartner () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.partnertelephone = res.Telefon
            this.partnername = res.Firma
            this.partneremail = res.Email
            this.buttondisabled = false
            if (typeof this.packagehandle === 'undefined' || this.packagehandle === null) {
              this.getbitrixinfo()
            }
          },
          response => {
            alert('error ')
          }
        )
    },
    getbitrixinfo () {
      this.haaId = localStorage.getItem('haaid')
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getPackage/' + this.haaId, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.packagehandle = res.data.PACKAGE_HANDLE
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    requestBitrixFeatures () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
        company_id: this.haaid,
        company_name: this.partnername,
        name: this.partnername,
        email: this.partneremail,
        phone: this.partnertelephone,
        features: this.actualfeaturecode,
        package_name: this.packagehandle,
        requestFrom: 'Web'
      }
      this.$http.post(this.$bitrixapi + 'bitrix/requestBitrixFeatures', data, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.hidemodal('success')
            this.$refs.successrequestfeature.show()
            this.wheretogo = 'success'
            this.loading = false
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    }
  }
}
</script>
<style>
#noneligeble___BV_modal_content_ {
  margin-top: 40%;
}
#successrequestfeature___BV_modal_content_ {
  margin-top: 40%;
}
#noneligeble___BV_modal_content_ .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#noneligeble___BV_modal_content_ .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#noneligeble___BV_modal_content_ .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#noneligeble___BV_modal_content_ .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#noneligeble___BV_modal_content_ .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// noneligibleFeaturepop.vue?6dde535f